import translations from "translations";

export default {
	"accessibility_declaration_heading": {
		"en": "Statement of accessibility rezerwacje.um.gdynia.pl",
		"pl": "Deklaracja dostępności rezerwacje.um.gdynia.pl",
		"ru": "Декларация доступности rezerwacje.um.gdynia.pl",
		"ua": "Декларація доступності rezerwacje.um.gdynia.pl"
	},

	"accessibility_1_paragraph_1": {
		"en": "The Gdynia City Hall undertakes to ensure the accessibility of its website in accordance with the provisions of the Act of 4 April 2019 on digital accessibility of websites and mobile applications of public entities. The statement of accessibility applies to the website <a target=\"_blank\" href=\"http://rezerwacje.um.gdynia.pl\"> rezerwacje.um.gdynia.pl </a>.",
		"pl": "Urząd Miasta Gdyni zobowiązuje się zapewnić dostępność swojej strony internetowej zgodnie z przepisami ustawy z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych. Oświadczenie w sprawie dostępności ma zastosowanie do strony internetowej <a target=\"_blank\" href=\"http://rezerwacje.um.gdynia.pl\"> rezerwacje.um.gdynia.pl </a>.",
		"ru": "Городское Управление Гдыни обязуется обеспечить доступность своего веб-сайта в соответствии с положениями Закона от 4 апреля 2019 года о цифровой доступности веб-сайтов и мобильных приложений государственных организаций. Заявление о доступности распространяется на веб-сайт <a target=\"_blank\" href=\"http://rezerwacje.um.gdynia.pl\"> rezerwacje.um.gdynia.pl </a>.",
		"ua": "Адміністрація Міста Ґдині зобов'язується забезпечити доступність свого веб-сайту відповідно до положень Закону від 4 квітня 2019 року про доступність цифрових веб-сайтів і мобільних додатків громадських організацій. Заява про доступність застосовується до веб-сайту <a target=\"_blank\" href=\"http://rezerwacje.um.gdynia.pl\"> rezerwacje.um.gdynia.pl </a>."
	},

	"accessibility_1_list_item_1": {
		"en": "Date of publication of website: <strong> 27.08.2021 </strong>",
		"pl": "Data publikacji strony internetowej: <strong> 27.08.2021 </strong>",
		"ru": "Дата публикации на сайте: <strong> 27.08.2021 </strong>",
		"ua": "Дата публікації веб-сайту: <strong> 27.08.2021 </strong>"
	},

	"accessibility_2_heading": {
		"en": "Status in terms of compliance with the Act ",
		"pl": "Status pod względem zgodności z ustawą",
		"ru": "Статус с точки зрения соответствия закону",
		"ua": "Статус з точки зору дотримання закону"
	},

	"accessibility_2_paragraph_1": {
		"en": "The website complies with the Act on digital accessibility of websites and mobile applications of public entities.",
		"pl": "Strona internetowa jest zgodna z ustawą o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.",
		"ru": "Веб-сайт соответствует Закону о цифровой доступности веб-сайтов и мобильных приложений государственных организаций.",
		"ua": "Веб-сайт відповідає закону про доступність цифрових веб-сайтів і мобільних додатків громадських організацій."
	},

	"accessibility_2_paragraph_1_1": {
		"en": "<strong> The site has the following facilities for people with disabilities: </strong>",
		"pl": "<strong> Strona posiada następujące ułatwienia dla osób z niepełnosprawnościami:</strong>",
		"ru": "<strong> На сайте предусмотрены следующие возможности для людей с ограниченными возможностями: </strong>",
		"ua": "<strong> Веб-сайт має наступні можливості для людей з обмеженими можливостями: </strong>"
	},
	
	"accessibility_2_list_item_0_1": {
		"en": "contrast version,",
		"pl": "wersję kontrastową, ",
		"ru": "контрастная версия,",
		"ua": "контрастна версія,"
	},

	"accessibility_2_list_item_0_2": {
		"en": "ability to resize text,",
		"pl": "możliwość zmiany rozmiaru tekstu,",
		"ru": "возможность изменения размера текста,",
		"ua": "можливість змінювати розмір тексту,"
	},

	"accessibility_2_list_item_0_3": {
		"en": "focus around navigation elements,",
		"pl": "focus wokół elementów nawigacyjnych",
		"ru": "фокус вокруг элементов навигации,",
		"ua": "фокусування навколо елементів навігації,"
	},

	"accessibility_2_list_item_0_4": {
		"en": "highlighting of links,",
		"pl": "wyróżnienie odnośników,",
		"ru": "выделение ссылок,",
		"ua": "підсвічування посилань, "
	},

	"accessibility_2_paragraph_1_2": {
		"en": "You can use standard browser keyboard shortcuts on the website.",
		"pl": "Na stronie internetowej można używać standardowych skrótów klawiaturowych przeglądarki.",
		"ru": "На сайте можно использовать стандартные сочетания клавиш браузера.",
		"ua": "Ви можете використовувати стандартні комбінації клавіш браузера на веб-сайті."
	},

	"accessibility_2_paragraph_2": {
		"en": "<strong> Preparation of statement of accessibility </strong>",
		"pl": "<strong> Przygotowanie deklaracji w sprawie dostępności </strong>",
		"ru": "<strong> Подготовка декларации о доступности </strong>",
		"ua": "<strong> Підготовка декларації про доступність </strong>"
	},

	"accessibility_2_list_item_1": {
		"en": "The Statement was prepared on: <strong> 27.08.2021 </strong>",
		"pl": "Deklarację sporządzono dnia: <strong> 27.08.2021 </strong>",
		"ru": "Декларация составлена: <strong> 27.08.2021 </strong>",
		"ua": "Декларація складена: <strong> 27.08.2021 </strong>"
	},

	"accessibility_2_list_item_2": {
		"en": "The declaration was last reviewed and updated on: <strong> 31.03.2025 </strong>",
		"pl": "Deklaracja została ostatnio poddana przeglądowi i aktualizacji dnia: <strong> 31.03.2025 </strong>",
		"ru": "Последний раз декларация была проверена и обновлена: <strong> 31.03.2025 </strong>",
		"ua": "Декларація востаннє переглядалася та оновлювалася: <strong> 31.03.2025 </strong>"
	},

	"accessibility_2_paragraph_3": {
		"en": "The Statement was prepared on the basis of a self-assessment carried out by the public entity.",
		"pl": "Deklarację sporządzono na podstawie samooceny przeprowadzonej przez podmiot publiczny.",
		"ru": "Заявление было сделано на основе самостоятельной	оценки,	проведенной государственным органом.",
		"ua": "Декларація складена на основі самостійної оцінки, здійсненої публічним суб'єктом."
	},

	"accessibility_3_heading": {
		"en": "Feedback and contact details ",
		"pl": "Informacje zwrotne i dane kontaktowe",
		"ru": "Обратная связь и контактные данные",
		"ua": "Зворотній зв'язок та контактна інформація"
	},

	"accessibility_3_list_1_item_1": {
		"en": "Processing of comments and suggestions: <strong> Michał Kowalski </strong>",
		"pl": "Za rozpatrywanie uwag i wniosków odpowiada: <strong> Michał Kowalski </strong>",
		"ru": "Ответственный за рассмотрение замечаний и заявлений: <strong> Михал Ковальски (Michał Kowalski) </strong>",
		"ua": "За розгляд заяв і висновків відповідає: <strong> Міхал Ковальський (Michał Kowalski) </strong>"
	},

	"accessibility_3_list_1_item_2": {
		"en": "E-mail: <a href=\"mailto:michal.kowalski@gdynia.pl\"> michal.kowalski@gdynia.pl </a>",
		"pl": "E-mail: <a href=\"mailto:michal.kowalski@gdynia.pl\"> michal.kowalski@gdynia.pl </a>",
		"ru": "Электронная почта: <a href=\"mailto:michal.kowalski@gdynia.pl\"> michal.kowalski@gdynia.pl </a>",
		"ua": "Електронна пошта: <a href=\"mailto:michal.kowalski@gdynia.pl\"> michal.kowalski@gdynia.pl </a>"
	},

	"accessibility_3_list_1_item_3": {
		"en": "Telephone: <a href=\"tel:585273552\"> 58 527 35 52 </a>",
		"pl": "Telefon: <a href=\"tel:585273552\"> 58 527 35 52 </a>",
		"ru": "Телефон: <a href=\"tel:585273552\"> 58 527 35 52 </a>",
		"ua": "Телефон: <a href=\"tel:585273552\"> 58 527 35 52 </a>"
	},

	"accessibility_3_paragraph_0": {
		"en": "The same route can be used to submit requests for unavailable information. ",
		"pl": "Tą samą drogą można składać wnioski o udostępnienie informacji niedostępnej. ",
		"ru": "Запросы на недоступную информацию могут быть поданы теми же способами.",
		"ua": "Запити на отримання інформації з обмеженим доступом можна подавати тими ж способами."
	},

	"accessibility_3_paragraph_1": {
		"en": "Everyone is entitled to:",
		"pl": "Każdy ma prawo:",
		"ru": "Каждый имеет право:",
		"ua": "Кожен має право:"
	},

	"accessibility_3_list_2_item_1": {
		"en": "comment on the digital accessibility of the site or its element,",
		"pl": "zgłosić uwagi dotyczące dostępności cyfrowej strony lub jej elementu,",
		"ru": "сообщить о замечаниях в отношении доступности страницы или ее части,",
		"ua": "повідомити про наявність цифрової сторінки або її елемента,"
	},

	"accessibility_3_list_2_item_2": {
		"en": "make a request for the digital accessibility of the site or its element,",
		"pl": "zgłosić żądanie zapewnienia dostępności cyfrowej strony lub jej elementu,",
		"ru": "отправить запрос на обеспечение цифровой доступности страницы или ее части,",
		"ua": "подати запит на забезпечення доступності цифрової сторінки або її елемента,"
	},

	"accessibility_3_list_2_item_3": {
		"en": "Request that the unavailable information be made available in another alternative form.",
		"pl": "wnioskować o udostępnienie niedostępnej informacji w innej alternatywnej formie.",
		"ru": "запрос о том, чтобы недоступная информация была предоставлена в другой альтернативной форме.",
		"ua": "вимагати, щоб недоступна інформація була надана в іншій альтернативній формі."
	},

	"accessibility_3_paragraph_2": {
		"en": "The request must include:",
		"pl": "Żądanie musi zawierać:",
		"ru": "Запрос должен включать:",
		"ua": "Запит повинен містити:"
	},

	"accessibility_3_list_3_item_1": {
		"en": "contact details of the submitter,",
		"pl": "dane kontaktowe osoby zgłaszającej,",
		"ru": "контактные данные лица, отправившего запрос,",
		"ua": "контактні дані заявника,"
	},

	"accessibility_3_list_3_item_2": {
		"en": "indication of the site or element of the site to which the request relates,",
		"pl": "wskazanie strony lub elementu strony, której dotyczy żądanie,",
		"ru": "указание страницы или части страницы, к которому относится запрос,",
		"ua": "вказівка сторінки або елемента сторони, на яку поширюється запит,"
	},

	"accessibility_3_list_3_item_3": {
		"en": "indication of the convenient form in which the information can be made available if the request is for the alternative provision of unavailable information,",
		"pl": "wskazanie dogodnej formy udostępnienia informacji, jeśli żądanie dotyczy, udostępnienia w formie alternatywnej informacji niedostępnej,",
		"ru": "указание удобной формы предоставления информации при наличии запроса на предоставление недоступной информации в альтернативной форме,",
		"ua": "вказівка зручної форми надання інформації, якщо запит стосується надання в альтернативній формі недоступної інформації,"
	},

	"accessibility_3_list_3_item_4": {
		"en": "indication of how to contact the person making the request.",
		"pl": "wskazanie sposobu kontaktu z osobą występującą z żądaniem.",
		"ru": "указание на то, как связаться с лицом, подающим запрос.",
		"ua": "вказівку на те, як зв'язатися з особою, яка подає запит."
	},

	"accessibility_3_paragraph_3": {
		"en": "The request should be processed without delay, at the latest within <strong> 7 days </strong>. If it is not possible to provide access within this deadline or to provide access in an alternative form, this should be done at the latest within 2 months from the date of notification.",
		"pl": "Rozpatrzenie zgłoszenia powinno nastąpić niezwłocznie, najpóźniej w ciągu <strong> 7 dni </strong>. Jeśli w tym terminie zapewnienie dostępności albo zapewnienie dostępu w alternatywnej formie nie jest możliwe, powinno nastąpić najdalej w ciągu 2 miesięcy od daty zgłoszenia.",
		"ru": "Уведомление должно быть рассмотрено незамедлительно, не позднее, чем в течение <strong> 7 дней </strong>. Если обеспечение доступности или обеспечение доступности в альтернативной форме доступа невозможны в течение этого периода, данное обеспечение доступности должно быть предоставлено в течение 2 месяцев с даты уведомления.",
		"ua": "Розгляд заяви має бути здійснений негайно, не пізніше <strong> 7 днів </strong> . Якщо протягом цього терміну забезпечення доступності або надання доступу в альтернативній формі не є можливими, це має відбутися протягом 2 місяців з дати подання заявки"
	},

	"accessibility_3_paragraph_4": {
		"en": "<strong> Complaints and appeals </strong>",
		"pl": "<strong> Skargi i odwołania </strong>",
		"ru": "<strong> Жалобы и апелляции </strong>",
		"ua": "<strong> Скарги та апеляції </strong> "
	},

	"accessibility_3_paragraph_5": {
		"en": "If these deadlines are not met, or if a request is denied, a complaint may be filed with the supervisory authority by post or by e-mail to:",
		"pl": "Na niedotrzymanie tych terminów oraz na odmowę realizacji żądania można złożyć skargę do organu nadzorującego pocztą lub drogą elektroniczną na adres:",
		"ru": "Если указанные сроки не были соблюдены или запрос был отклонен, Вы можете подать жалобу в надзорный орган по почте или по электронной почте по следующему адресу:",
		"ua": "Ви можете подати скаргу до наглядового органу за допомогою пошти або електронної пошти за адресою:"
	},

	"accessibility_3_list_4_item_1": {
		"en": "Supervisory authority: <a target=\"_blank\" href=\"https://bip.um.gdynia.pl/organy-doradcze,1757/zespol-ds-dostepnosci-osobom-ze-szczegolnymi-potrzebami-w-obiektach-uzytecznosci-publicznej-nalezacych-do-gminy-miasta-gdyni,556646\"> Team for accessibility to persons with special needs in public facilities belonging to the Municipality of Gdynia (Zespół ds. dostępności osobom ze szczególnymi potrzebami w obiektach użyteczności publicznej należących do Gminy Miasta Gdyni) </a>",
		"pl": "Organ nadzorujący: <a target=\"_blank\" href=\"https://bip.um.gdynia.pl/organy-doradcze,1757/zespol-ds-dostepnosci-osobom-ze-szczegolnymi-potrzebami-w-obiektach-uzytecznosci-publicznej-nalezacych-do-gminy-miasta-gdyni,556646\">Zespół ds. dostępności osobom ze szczególnymi potrzebami w obiektach użyteczności publicznej należących do Gminy Miasta Gdyni</a>",
		"ru": "Контрольный орган: <a target=\"_blank\" href=\"https://bip.um.gdynia.pl/organy-doradcze,1757/zespol-ds-dostepnosci-osobom-ze-szczegolnymi-potrzebami-w-obiektach-uzytecznosci-publicznej-nalezacych-do-gminy-miasta-gdyni,556646\"> Группа по обеспечению доступности общественных объектов, принадлежащих гмине города Гдыня, для людей с особыми потребностями </a>",
		"ua": "Наглядовий орган: <a target=\"_blank\" href=\"https://bip.um.gdynia.pl/organy-doradcze,1757/zespol-ds-dostepnosci-osobom-ze-szczegolnymi-potrzebami-w-obiektach-uzytecznosci-publicznej-nalezacych-do-gminy-miasta-gdyni,556646\"> Група з доступності для осіб з особливими потребами в громадських об'єктах, що належать Ґміні Міста Ґдині </a>"
	},

	"accessibility_3_list_4_item_2": {
		"en": "Address: <strong> Gdynia City Hall, aleja Marsz. Piłsudskiego 52/54 </strong>",
		"pl": "Adres: <strong> Urząd Miasta Gdyni aleja Marsz. Piłsudskiego 52/54 </strong>",
		"ru": "Адрес: <strong> Городское Управление Гдыни, ал. Маршала Пилсудского 52/54 (al. Marszałka Piłsudskiego 52/54) </strong> ",
		"ua": "Адреса: <strong> Адміністрація Міста Ґдині алея Марш. Пілсудського 52/54 (al. Marszałka Piłsudskiego 52/54) </strong> "
	},

	"accessibility_3_list_4_item_3": {
		"en": "E-mail: <a href=\"mailto:dostepnosc@gdynia.pl\"> dostepnosc@gdynia.pl </a>",
		"pl": "E-mail: <a href=\"mailto:dostepnosc@gdynia.pl\"> dostepnosc@gdynia.pl </a>",
		"ru": "Электронная почта: <a href=\"mailto:dostepnosc@gdynia.pl\"> dostepnosc@gdynia.pl </a>",
		"ua": "Електронна пошта: <a href=\"mailto:dostepnosc@gdynia.pl\"> dostepnosc@gdynia.pl </a>"
	},

	"accessibility_3_list_4_item_4": {
		"en": "Telephone: <a href=\"tel:585273820\"> 58 527-38-20 </a>",
		"pl": "Telefon: <a href=\"tel:585273820\"> 58 527-38-20 </a>",
		"ru": "Телефон: <a href=\"tel:585273820\"> 58 527-38-20 </a>",
		"ua": "Телефон: <a href=\"tel:585273820\"> 58 527-38-20 </a>"
	},

	"accessibility_3_paragraph_6": {
		"en": "A complaint can also be submitted to the <a target=\"_blank\" href=\"https://www.rpo.gov.pl/content/jak-zglosic-sie-do-rzecznika-praw-obywatelskich\"> Commissioner for Human Rights (Rzecznika Praw Obywatelskich).</a>",
		"pl": "Skargę można złożyć również do <a target=\"_blank\" href=\"https://www.rpo.gov.pl/content/jak-zglosic-sie-do-rzecznika-praw-obywatelskich\"> Rzecznika Praw Obywatelskich </a>.",
		"ru": "Вы также можете подать жалобу <a target=\"_blank\" href=\"https://www.rpo.gov.pl/content/jak-zglosic-sie-do-rzecznika-praw-obywatelskich\"> Уполномоченному по гражданским правам </a>.",
		"ua": "Скарга також може бути подана <a target=\"_blank\" href=\"https://www.rpo.gov.pl/content/jak-zglosic-sie-do-rzecznika-praw-obywatelskich\"> Омбудсмену </a>."
	},

	"accessibility_4_heading": {
		"en": "Architectural accessibility",
		"pl": "Dostępność architektoniczna",
		"ru": "Архитектурная доступность",
		"ua": "Архітектурна доступність"
	},

	"accessibility_4_paragraph_1": {
		"en": "<strong> I. Building at al. Marszałka Piłsudskiego 52-54 </strong>",
		"pl": "<strong> I. Budynek mieszczący się przy al. Marszałka Piłsudskiego 52-54 </strong>",
		"ru": "<strong> I. Здание, расположенное по адресу ал. Маршала Пилсудского 52/54 (al. Marszałka Piłsudskiego 52/54) </strong>",
		"ua": "<strong> I. Будівля, розташована на вулиці ал. Маршала Пілсудського 52-54 (al. Marszałka Piłsudskiego 52/54) </strong>"
	},

	"accessibility_4_paragraph_2": {
		"en": "<strong> Entrance from al. Marszałka Piłsudskiego </strong>",
		"pl": "<strong> Wejścia od al. Marszałka Piłsudskiego </strong>",
		"ru": "<strong> Вход со стороны ал. Маршала Пилсудского (al. Marszałka Piłsudskiego) </strong>",
		"ua": "<strong> Вхід зі сторони ал. Маршала Пілсудського (al. Marszałka Piłsudskiego) </strong> "
	},

	"accessibility_4_list_1_item_1": {
		"en": "Entrance A - directly from the sidewalk, without architectural barriers; you can get information at the Information desk.",
		"pl": "Wejście A - bezpośrednio z chodnika, bez barier architektonicznych; możliwość pozyskania informacji w punkcie Informacji.",
		"ru": "Вход A - прямо с тротуара, без архитектурных барьеров; информацию можно получить на стойке информации.",
		"ua": "Вхід А - безпосередньо з тротуару, без архітектурних бар'єрів; інформація доступна на інформаційній стійці."
	},

	"accessibility_4_list_1_item_2": {
		"en": "Entrance B to the Registry Office - directly from the sidewalk, inside the stairs with contrasting step markings.",
		"pl": "Wejście B do Urzędu Stanu Cywilnego - bezpośrednio z chodnika, wewnątrz schody z kontrastowymi oznaczeniami stopni.",
		"ru": "Вход B в ЗАГС - прямо с тротуара, внутренняя лестница с контрастной разметкой ступеней.",
		"ua": "Вхід В до РАЦСу - прямо з тротуару, всередині сходи з контрастним маркуванням сходинок."
	},

   "accessibility_4_paragraph_3": {
		"en": "<strong> Entrance from Świętojańska Street </strong>",
		"pl": "<strong> Wejścia od ulicy Świętojańskiej </strong>",
		"ru": "<strong> Вход со Свентоянской улицы (ul. Świętojańska) </strong>",
		"ua": "<strong> Вхід з вулиці Щвентояньска (ul. Świętojańskа) </strong> "
	},

   "accessibility_4_list_2_item_1": {
		"en": "Entrance C - directly from the sidewalk, access via a vertical elevator (elevator) also to the Registry Office.",
		"pl": "Wejście C – bezpośrednio z chodnika, dostęp za pomocą podnośnika pionowego (windy) również do Urzędu Stanu Cywilnego.",
		"ru": "Вход C - непосредственно с тротуара, доступ через вертикальный лифт (подъемник) также к ЗАГСу.",
		"ua": "Вхід С - безпосередньо з тротуару, доступ через вертикальний підйомник (ліфт) також до РАЦСу."
	},

	"accessibility_4_list_2_item_2": {
		"en": "Entrance D - directly from the sidewalk, inside the stairs.",
		"pl": "Wejście D - bezpośrednio z chodnika, wewnątrz schody.",
		"ru": "Вход D - прямо с тротуара, внутри лестницы.",
		"ua": "Вхід D - прямо з тротуару, внутрішні сходи."
	},

   "accessibility_4_paragraph_4": {
      "en": "<strong> Description of building accessibility </strong>",
      "pl": "<strong> Opis dostępności budynku </strong>",
      "ru": "<strong> Описание доступности здания </strong>",
      "ua": "<strong> Опис доступності будівлі </strong>"
   },

   "accessibility_4_list_3_item_1": {
      "en": "1. Horizontal and vertical communication: <br/> corridors provide free movement, wide stairs marked with contrasting tape. There are 2 elevators in the building, where the panel contains information in relief writing and Braille. Voice information is provided by 1 elevator.",
      "pl": "1. Komunikacja pozioma i pionowa: <br/> korytarze zapewniają swobodne przemieszczanie się, schody szerokie oznaczone kontrastową taśmą. W budynku znajdują się 2 windy, w których panel zawiera informacje w piśmie wypukłym i alfabecie Braille'a. Informację głosową posiada 1 winda.",
      "ru": "1. Горизонтальные и вертикальные коммуникации: <br/> коридоры обеспечивают свободное передвижение, широкие лестницы обозначены контрастной лентой. В здании 2 лифта, на панели которых размещена информация рельефным шрифтом и шрифтом Брайля. Голосовая информация предоставляется в 1 лифте.",
      "ua": "1. Горизонтальна та вертикальна комунікація: <br/> коридори забезпечують вільне пересування, широкі сходи позначені контрастною стрічкою. У будівлі є 2 ліфти, на панелі яких розміщена інформація рельєфно-крапковим шрифтом і шрифтом Брайля. В 1 ліфті надається голосова інформація."
   },

   "accessibility_4_list_3_item_2": {
      "en": "2. Description of adaptations: <br/> upon entering the building Information Desk; <br/> ramp leading to the Residents' Service Room.",
      "pl": "2.  Opis dostosowań: <br/> po wejściu do budynku Punkt Informacji; <br/> pochylnia prowadząca do Sali Obsługi Mieszkańców.",
      "ru": "2. Описание приспособлений: <br/> при входе в здание информационный пункт; <br/> пандус, ведущий в комнату обслуживания жильцов.",
      "ua": "2. Опис адаптацій: <br/> при вході в будівлю Інформаційний пункт; <br/> пандус, що веде до кімнати обслуговування мешканців."
   },

   "accessibility_4_list_3_item_3": {
      "en": "3. Information on where and how to use parking spaces designated for people with disabilities: <br/> 2 parking spaces on Bema Street and 3 parking spaces in the parking lot behind the building. Parking spaces dedicated to people with disabilities are free of charge.",
      "pl": "3. Informacje o miejscu i sposobie korzystania z miejsc parkingowych wyznaczonych dla osób z niepełnosprawnością: <br/> 2 miejsca postojowe przy ulicy Bema i 3 miejsca postojowe na parkingu za budynkiem. Miejsca postojowe dedykowane osobom z niepełnosprawnością są bezpłatne.",
      "ru": "3. Информация о том, где и как использовать парковочные места, предназначенные для людей с ограниченными возможностями: <br/> 2 парковочных места на улице Бема и 3 парковочных места на парковке за зданием. Парковочные места, предназначенные для людей с ограниченными возможностями, предоставляются бесплатно.",
      "ua": "3. Інформація про те, де і як користуватися паркувальними місцями, призначеними для людей з інвалідністю: <br/> 2 паркомісця на вулиці Бема та 3 паркомісця на автостоянці за будівлею. Паркувальні місця, призначені для осіб з інвалідністю, є безкоштовними."
   },

   "accessibility_4_list_3_item_4": {
      "en": "4. Information about the right to enter with an assistance dog and any reasonable restrictions: <br/> Anyone may enter the building with an assistance dog or guide dog.",
      "pl": "4. Informacja o prawie wstępu z psem asystującym i ewentualnych uzasadnionych ograniczeniach: <br/> każdy może wejść do budynku z psem asystującym lub psem przewodnikiem.",
      "ru": "4. Информация о праве на вход с собакой-поводырем и любых разумных ограничениях: <br/> Любой человек может войти в здание с собакой-помощником или собакой-проводником.",
      "ua": "4. Інформація про право входу з собакою-поводирем та будь-які обґрунтовані обмеження: <br/> Будь-хто може увійти до будівлі з собакою-поводирем або собакою-поводирем."
   },

   "accessibility_4_list_3_item_5": {
      "en": "5. Information about the possibility of using an on-site sign language interpreter: <br/> A Polish Sign Language interpreter is available online, on Mondays and Fridays from 9 a.m. to 3 p.m. Link to website: https://tlumacz.um.gdynia.pl. Deaf people can also contact us via text message, at 519 071 505. Please send only text messages without photos.",
      "pl": "5. Informacje o możliwości skorzystania z tłumacza języka migowego na miejscu: <br/> Tłumacz Polskiego Języka Migowego jest dostępny online, w poniedziałki i piątki w godzinach od 9.00 do 15.00. Link do strony: https://tlumacz.um.gdynia.pl. Osoby głuche mogą również kontaktować się z nami poprzez SMS, na numer telefonu 519 071 505. Prosimy o przesyłanie wyłącznie wiadomości tekstowych bez zdjęć.",
      "ru": "5. Информация о возможности использования сурдопереводчика на месте: <br/> Переводчик польского языка жестов доступен в режиме онлайн по понедельникам и пятницам с 9 до 15 часов. Ссылка на сайт: https://tlumacz.um.gdynia.pl. Глухие люди также могут связаться с нами с помощью текстовых сообщений по номеру 519 071 505. Пожалуйста, отправляйте только текстовые сообщения без фотографий.",
      "ua": "5. Інформація про можливість скористатися послугами перекладача жестової мови на місці: <br/> Перекладач польської жестової мови доступний в Інтернеті з понеділка по п'ятницю з 9.00 до 15.00. Посилання на сайт: https://tlumacz.um.gdynia.pl. Глухі люди можуть також зв'язатися з нами за допомогою текстових повідомлень на номер 519 071 505. Будь ласка, надсилайте текстові повідомлення тільки без фотографій."
   },

   "accessibility_4_list_3_item_6": {
      "en": "6. Toilet: <br/> on the first floor of the building next to the Submission Office there is an accessible toilet for people with disabilities equipped with a baby changing station.",
      "pl": "6. Toaleta: <br/> na parterze budynku obok Biura Podawczego znajduje się toaleta dostępna dla osób z niepełnosprawnością wyposażona w przewijak dla dzieci.",
      "ru": "6. Туалет: <br/> на первом этаже здания рядом с офисом Submission есть туалет для инвалидов, оборудованный станцией для переодевания детей.",
      "ua": "6. Туалет: <br/> на першому поверсі будівлі поруч з офісом подання заявок є туалет для людей з обмеженими фізичними можливостями, обладнаний пеленальною станцією для сповивання дітей."
   },

   "accessibility_4_paragraph_5": {
      "en": "<strong> II. The building located at 24 10 Lutego Street </strong>",
      "pl": "<strong> II. Budynek mieszczący się przy ulicy 10 Lutego 24 </strong>",
      "ru": "<strong> II. Здание, расположенное по адресу: улица Лютего, 24 10 </strong>",
      "ua": "<strong> II. Будівля за адресою вул. Лютего, 24 10 </strong>"
   },

   "accessibility_4_list_4_item_1": {
      "en": "1. Entrance A to the Resident Service Room - directly from the sidewalk; inside, a document drop box.",
      "pl": "1. Wejście A do Sali Obsługi Mieszkańca - bezpośrednio z chodnika; wewnątrz wrzutnia na dokumenty.",
      "ru": "1. Вход A в комнату обслуживания резидентов - прямо с тротуара; заход для получения документов внутри.",
      "ua": "1. Вхід А до кімнати обслуговування мешканців - прямо з тротуару; документи можна здати всередині."
   },

   "accessibility_4_list_4_item_2": {
      "en": "2. Entrance B to the City Hall of Gdynia and the Board of Roads and Greenery in Gdynia -directly from the sidewalk, without architectural barriers; the possibility of direct contact with employees of the City Guard.",
      "pl": "2. Wejście B do Urzędu Miasta Gdyni oraz Zarządu Dróg i Zieleni w Gdyni -bezpośrednio z chodnika, bez barier architektonicznych; możliwość bezpośredniego kontaktu z pracownikami Straży Miejskiej.",
      "ru": "2. Вход B в мэрию Гдыни и Управление дорог и озеленения Гдыни - прямо с тротуара, без архитектурных барьеров; возможность прямого контакта с сотрудниками городской охраны.",
      "ua": "2. Вхід B до мерії Гдині та Управління доріг та зелених насаджень Гдині - безпосередньо з тротуару, без архітектурних бар'єрів; можливість прямого контакту з працівниками міської варти."
   },

   "accessibility_4_list_4_item_3": {
      "en": "3. Entrance C to City Information directly from the sidewalk, without architectural barriers.",
      "pl": "3. Wejście C do Informacji Miejskiej bezpośrednio z chodnika, bez barier architektonicznych.",
      "ru": "3. Вход C в City Information прямо с тротуара, без архитектурных барьеров.",
      "ua": "3. Вхід C до City Information прямо з тротуару, без архітектурних бар'єрів."
   },

   "accessibility_4_paragraph_6": {
      "en": "<strong> Description of building accessibility </strong>",
      "pl": "<strong> Opis dostępności budynku </strong>",
      "ru": "<strong> Описание доступности здания </strong>",
      "ua": "<strong> Опис доступності будівлі </strong>"
   },

   "accessibility_4_list_5_item_1": {
      "en": "1. Horizontal and vertical communication: <br/> corridors provide free movement, wide stairs with contrast marking of the edges of the first and last steps. In the building (entrance B) there is an elevator with a panel that has no touch and voice information. From the 1st floor onward, there is a 2nd elevator available with voice information and a touch panel with no information for the blind.",
      "pl": "1. Komunikacja pozioma i pionowa: <br/> korytarze zapewniają swobodne przemieszczanie się, schody szerokie z oznaczeniem kontrastowym krawędzi pierwszego i ostatniego stopnia. W budynku (wejście B) znajduje się winda z panelem nieposiadającym informacji dotykowej i głosowej. Od 1 piętra dostępna 2 winda posiadająca informację głosową i panel dotykowy, nieposiadający informacji dla osób niewidomych.",
      "ru": "1. Горизонтальные и вертикальные коммуникации: <br/> коридоры обеспечивают свободное движение, лестницы широкие с контрастной маркировкой края первой и последней ступени. В здании (вход B) есть лифт с панелью без тактильной и голосовой информации. Начиная с 1-го этажа, имеется 2-й лифт с голосовой информацией и сенсорной панелью без информации для слабовидящих.",
      "ua": "1. Горизонтальна та вертикальна комунікація: <br/> коридори забезпечують вільне пересування, широкі сходи з контрастним маркуванням краю першої та останньої сходинки. У будівлі (вхід В) є ліфт з панеллю без тактильної та голосової інформації. Починаючи з 1-го поверху, є 2-й ліфт з голосовою інформацією та сенсорною панеллю без інформації для людей з вадами зору."
   },

   "accessibility_4_list_5_item_2": {
      "en": "2. Description of adjustments: <br/> any information can be provided by the person employed at the gatehouse.",
      "pl": "2. Opis dostosowań: <br/> wszelkich informacji może udzielać osoba zatrudniona w portierni.",
      "ru": "2. Описание приспособлений: <br/> любая информация может быть предоставлена сотрудником сторожки.",
      "ua": "2. Опис пристосувань: <br/> будь-яку інформацію може надати особа, яка працює на прохідній."
   },

   "accessibility_4_list_5_item_3": {
      "en": "3. Description of adjustments: <br/> any information can be provided by the person employed at the gatehouse.",
      "pl": "3. Informacje o miejscu i sposobie korzystania z miejsc parkingowych wyznaczonych dla osób z niepełnosprawnością: <br/>2 miejsca postojowe naprzeciwko budynku. Miejsca postojowe dedykowane osobom z niepełnosprawnością są bezpłatne.",
      "ru": "3. Описание приспособлений: <br/> любая информация может быть предоставлена сотрудником сторожки.",
      "ua": "3. Опис пристосувань: <br/> будь-яку інформацію може надати особа, яка працює на прохідній."
   },

   "accessibility_4_list_5_item_4": {
      "en": "4. Information about the right to enter with an assistance dog and any reasonable restrictions: <br/> Anyone may enter the building with an assistance dog or guide dog.",
      "pl": "4. Informacja o prawie wstępu z psem asystującym i ewentualnych uzasadnionych ograniczeniach: <br/> każdy może wejść do budynku z psem asystującym lub psem przewodnikiem.",
      "ru": "4. Информация о праве на вход с собакой-поводырем и любых разумных ограничениях: <br/> Любой человек может войти в здание с собакой-помощником или собакой-проводником.",
      "ua": "4. Інформація про право входу з собакою-поводирем та будь-які обґрунтовані обмеження: <br/> Будь-хто може увійти до будівлі з собакою-поводирем або собакою-поводирем."
   },

   "accessibility_4_list_5_item_5": {
      "en": "5. Information about the possibility of using an on-site sign language interpreter: <br/> A Polish Sign Language interpreter is available online, on Mondays and Fridays from 9 a.m. to 3 p.m. Link to website: https://tlumacz.um.gdynia.pl. Deaf people can also contact us via text message, at 519 071 505. Please send only text messages without photos.",
      "pl": "5. Informacje o możliwości skorzystania z tłumacza języka migowego na miejscu: <br/> Tłumacz Polskiego Języka Migowego jest dostępny online, w poniedziałki i piątki w godzinach od 9.00 do 15.00. Link do strony: https://tlumacz.um.gdynia.pl. Osoby głuche mogą również kontaktować się z nami poprzez SMS, na numer telefonu 519 071 505. Prosimy o przesyłanie wyłącznie wiadomości tekstowych bez zdjęć.",
      "ru": "5. Информация о возможности использования сурдопереводчика на месте: <br/> Переводчик польского языка жестов доступен в режиме онлайн по понедельникам и пятницам с 9 до 15 часов. Ссылка на сайт: https://tlumacz.um.gdynia.pl. Глухие люди также могут связаться с нами с помощью текстовых сообщений по номеру 519 071 505. Пожалуйста, отправляйте только текстовые сообщения без фотографий.",
      "ua": "5. Інформація про можливість скористатися послугами перекладача жестової мови на місці: <br/> Перекладач польської жестової мови доступний в Інтернеті з понеділка по п'ятницю з 9.00 до 15.00. Посилання на сайт: https://tlumacz.um.gdynia.pl. Глухі люди можуть також зв'язатися з нами за допомогою текстових повідомлень на номер 519 071 505. Будь ласка, надсилайте текстові повідомлення тільки без фотографій."
   },
   
   "accessibility_4_list_5_item_6": {
      "en": "6. Toilet: <br/> There is no accessible toilet in the building for people with disabilities.",
      "pl": "6. Toaleta: <br/> w budynku nie ma toalety dostępnej dla osób z niepełnosprawnością.",
      "ru": "6. Туалеты: <br/> В здании нет туалета, доступного для инвалидов.",
      "ua": "6. Туалети: <br/> у будівлі немає туалету, пристосованого для людей з інвалідністю."
   },
	
	"accessibility_5_heading": {
		"en": "Mobile applications",
		"pl": "Aplikacje mobilne",
		"ru": "Мобильные приложения",
		"ua": "Мобільні додатки"
	},

	"accessibility_5_paragraph": {
		"en": "Gdynia City Hall provides the following mobile applications:",
		"pl": "Urząd Miasta Gdyni udostępnia następujące aplikacje mobilne:",
		"ru": "Городское управление Гдыни предоставляет для использования следующие мобильные приложения:",
		"ua": "Адміністрація Міста Ґдині надає наступні мобільні додатки:"
	},

	"accessibility_5_list_item_1": {
		"en": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Aplikacja Gdynia.pl – Gdynia.pl application </a>",
		"pl": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Aplikacja Gdynia.pl </a>",
		"ru": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Приложение Gdynia.pl </a>",
		"ua": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Додаток Gdynia.pl </a>"
	},

	"accessibility_5_list_item_2": {
		"en": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Gdynia City Guide </a>",
		"pl": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Gdynia City Guide </a>",
		"ru": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Путеводитель по Гдыне (Gdynia City Guide) </a>.",
		"ua": "<a target=\"_blank\" href=\"https://www.gdynia.pl/o-gdyni/gdynskie-aplikacje,7254/aplikacje,496218\"> Gdynia City Guide </a>"
	}
}